/* eslint-disable no-undef */

async function handleAddToCartClick(clickedButton) {
	if (clickedButton) {
		const variantDataItem = clickedButton.dataset;
		const variantId = clickedButton.getAttribute('data-variant-id');
		const variantData = {
			items: [
				{
					id: variantId,
					quantity: 1,
					properties: {
						_item_category_2: variantDataItem.itemCategory2,
						_item_category_3: variantDataItem.itemCategory3,
						_item_category_4: variantDataItem.itemCategory4,
						_item_category_5: variantDataItem.itemCategory5,
					},
				},
			],
		};
		// Add the new property conditionally
		if (Shopify.shop.includes('limore')) {
			variantData.items[0].properties._add_from = 'online store';
		}
		// Custom function in theme.js
		addtems(variantData);
	}
}

const packsWrapper = document.querySelector('.packs-wrapper');
packsWrapper?.addEventListener('click', async (e) => {
	const clickedButton = e.target.closest('.product-form__cart-submit');
	await handleAddToCartClick(clickedButton);
});